import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Btn } from '../components/ui';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate  = useNavigate();
  const [email,    setEmail]    = useState();
  const [password, setPassword] = useState();
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await login(email.trim().toLowerCase(), password);
      navigate('/');
    } catch (err) {
      const msg = err?.response?.data;
      if (typeof msg === 'object') setError(Object.values(msg).flat().join(' '));
      else setError('Invalid email or password. Try Demo1234!');
    } finally { setLoading(false); }
  };

  return (
    <div className="screen" style={{ background: 'var(--surface)' }}>
      <div className="scroll">
        <div style={{ display:'flex', flexDirection:'column', justifyContent:'center', minHeight:'100%', padding:'40px 28px' }}>
          {/* Logo */}
          <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:8 }}>
            <div style={{ width:48, height:48, borderRadius:14, background:'var(--blue)', display:'flex', alignItems:'center', justifyContent:'center' }}>
              <svg width="24" height="24" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="6" stroke="#fff" strokeWidth="1.8"/>
                <path d="M10 7v4l2.5 1.5" stroke="#fff" strokeWidth="1.6" strokeLinecap="round"/>
              </svg>
            </div>
            <div>
              <div style={{ fontSize:22, fontWeight:700, color:'var(--text)', letterSpacing:'-0.03em' }}>ELO Insights</div>
              <div style={{ fontSize:12, color:'var(--text2)' }}>Whitehead Ross Education &amp; Consulting</div>
            </div>
          </div>

          <div style={{ fontSize:14, color:'var(--text2)', marginBottom:28, marginTop:6 }}>
            Sign in with your school account
          </div>

          {error && (
            <div style={{ background:'var(--red-l)', borderRadius:'var(--rs)', padding:'10px 14px', marginBottom:16, fontSize:13, color:'var(--red-d)', lineHeight:1.5 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="field-gap">
              <div className="field-lbl">Email address</div>
              <input
                className="fi"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="your@school.edu"
                required
              />
            </div>
            <div className="field-gap" style={{ marginBottom:8 }}>
              <div className="field-lbl">Password</div>
              <input
                className="fi"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            {/* <div style={{ fontSize:12, color:'var(--blue)', textAlign:'right', marginBottom:20, cursor:'pointer' }}>
              Forgot password?
            </div> */}
            <Btn variant="blue" onClick={handleSubmit} loading={loading}>Sign in</Btn>
          </form>

          <div style={{ background:'var(--blue-l)', borderRadius:'var(--rs)', padding:'10px 14px', marginTop:16, fontSize:12, color:'var(--nav)', lineHeight:1.5 }}>
             Role and access are set by your administrator.
          </div>
        </div>
      </div>
    </div>
  );
}
